// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"44828569","268":"177a19a8","441":"fc041dab"}[chunkId] + ".chunk.js";
};